import { render, staticRenderFns } from "./admin-messages.vue?vue&type=template&id=adbe415a&scoped=true"
import script from "./admin-messages.vue?vue&type=script&lang=js"
export * from "./admin-messages.vue?vue&type=script&lang=js"
import style0 from "./admin-messages.vue?vue&type=style&index=0&id=adbe415a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbe415a",
  null
  
)

export default component.exports